import styled from 'styled-components';
import { getStyles } from '../../utils/getStyles/getStyles';
export const ParentContainerStyled = styled.div `
  ${props => getStyles(props.styles.container)}
`;
export const BarContainerStyled = styled.div `
  ${props => getStyles(props.styles.barContainer)}
`;
export const BarStyled = styled.div `
  ${props => getStyles(props.styles.bar)}
  ${props => getStyles(props.sizeStyles?.bar)}
  background-color: ${props => props.color};
`;
export const ProgressBarStyled = styled.div `
  ${props => getStyles(props.styles.progressBar)}
  ${props => getStyles(props.sizeStyles?.progressBar)}
  width: ${({ progressCompleted }) => `${progressCompleted}%`};
  transition: ${({ progressAnimation }) => `width ${progressAnimation?.duration} ${progressAnimation?.timingFunction}`};
  background-color: ${props => props.color};
`;
//# sourceMappingURL=progressBar.styled.js.map